import DeleteImg from 'assets/img/delete_img.png';
import { Hooks } from 'providers';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  HIT_BACKOFFICE_LIST,
  HIT_BO_COMPANY_DELETE,
} from 'redux/actions/backOffice';
import { useDeleteBoardMutation } from 'components/board/hooks/useBoard';
import {
  HIT_DELETE_PROCESS,
  HIT_INDEX_VIEW,
  HIT_TREE_VIEW,
} from 'redux/actions/business_process';
import { DO_LOADING } from 'redux/actions/loading';
import {
  HIT_EMPLOYEE_CHART,
  HIT_LIST_EMPLOYEE,
  HIT_UPDATE_EMPLOYEE,
  HIT_UPDATE_STRUCTURE,
} from 'redux/actions/organization';
import { apiUpdateEmployee } from 'redux/api/organization';
import { HIT_CVC_LVL_1 } from 'redux/actions/cvc';
import { useDeleteBOCompany } from 'components/backoffice/company/hooks/useCompanyMutation';
import title from './title';

function DeleteBoard(props) {
  const { isFocusPosition, idFocus, pagination } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    modalDelete,
    setModalDelete,
    setModal,
    boardNow,
    text: textPopUp,
  } = useContext(Hooks);
  const deleteBoardMutation = useDeleteBoardMutation();
  const [text, setText] = useState('');
  const { mutate: deleteBOCompany } = useDeleteBOCompany();

  const DeleteBoard__ = async () => {
    if (props.for === 'bo-company') {
      const payloadDelete = {
        company_id: props.id,
      };
      deleteBOCompany(payloadDelete);
    } else if (props.for === 'bussines-process') {
      dispatch({
        type: HIT_DELETE_PROCESS,
        payload: {
          process_id: props.id,
        },
      });
      setTimeout(() => {
        if (props.hit === 'index-view') {
          dispatch({
            type: HIT_INDEX_VIEW,
            payload: {
              // board_id: "4e185c25-0e55-4a15-98b1-7d1b5399c420",
              board_id: localStorage.getItem('board_id'),
            },
          });
        } else {
          dispatch({
            type: HIT_TREE_VIEW,
            payload: {
              // board_id: "4e185c25-0e55-4a15-98b1-7d1b5399c420",
              board_id: localStorage.getItem('board_id'),
            },
          });
          dispatch({
            type: HIT_CVC_LVL_1,
            payload: {
              board_id: localStorage.getItem('board_id'),
              level: '1',
            },
          });
        }
      }, 500);
    } else if (props?.for === 'structure_view') {
      dispatch({
        type: HIT_UPDATE_STRUCTURE,
        payload: {
          data: props.data,
          board_id: localStorage.getItem('board_id'),
          isFocusPosition,
          idFocus,
        },
      });
    } else if (props?.for === 'list_employee') {
      try {
        const update = await apiUpdateEmployee(props.data);
        dispatch({
          type: HIT_UPDATE_EMPLOYEE,
          payload: {
            status: 'success',
            message: 'Perubahan data berhasil di simpan',
          },
        });
        setTimeout(() => {
          dispatch({
            type: HIT_EMPLOYEE_CHART,
            payload: {
              board_id: localStorage.getItem('board_id'),
            },
          });
          dispatch({
            type: HIT_LIST_EMPLOYEE,
            payload: {
              board_id: localStorage.getItem('board_id'),
              limit: pagination.limit,
              offset: pagination.offset,
            },
          });
        }, 300);
      } catch (error) {
        dispatch({
          type: HIT_UPDATE_EMPLOYEE,
          payload: {
            status: 'failed',
            message: error.message,
          },
        });
        dispatch({ type: DO_LOADING, payload: false });
      }
    } else {
      await deleteBoardMutation.mutateAsync({
        board_id: boardNow,
      });
    }

    setModalDelete(false);
    setModal(false);
  };
  useEffect(() => {
    if (props.for === 'bo-company') {
      setText(t('general.message.del_company_message'));
    } else if (props.for === 'board') {
      setText(t('general.message.del_board_message'));
    } else if (props.for === 'bussines-process') {
      setText(t('general.message.del_bp_message'));
    } else if (props.for === 'structure_view') {
      setText(t('general.message.del_structure_message'));
    } else if (props.for === 'list_employee') {
      setText(t('general.message.del_employee_message'));
    } else {
      setText(
        'WARNING! This action cannot be reverted, it will delete your boardAA and all of the data inside the board, do you wish to continue?',
      );
    }
  }, [t]);
  useEffect(() => {}, [modalDelete]);
  return (
    <div
      className={`modal fade rModal ${
        modalDelete && !textPopUp.company_id && 'show'
      }`}
      id="deleteModal"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-sm" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title({ data: props.for, t })}</h5>
            <button
              id="delete-button-close"
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setModalDelete(false);
                setModal(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body m-3">
            <img src={DeleteImg} className="rModalImg" />
            <p className="mb-0">{text}</p>
          </div>
          <div className="modal-footer">
            <button
              id="delete-button-cancel"
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={() => {
                setModalDelete(false);
                setModal(false);
              }}
            >
              {t('biz_process.cancel')}
            </button>
            <button
              id="delete-button-continue"
              onClick={() => {
                DeleteBoard__();
              }}
              type="button"
              data-dismiss="modal"
              className="btn btn-primary"
            >
              {t('workload_landing.continue')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteBoard;
